import { apiService } from './apiService'

export const schedulerService = {
  status: () => apiService.get('/api/scheduler/status'),
  pause: (lane) => apiService.post('/api/scheduler/pause', { lane }),
  resume: (lane) => apiService.post('/api/scheduler/resume', { lane }),
  plan: (lane, mode = 'full') => apiService.post('/api/scheduler/plan', { lane, mode }),
  setReconciliation: (enabled) => apiService.post('/api/scheduler/reconciliation', { enabled }),
  retryJob: (lane, jobId) => apiService.post(`/api/scheduler/jobs/${lane}/${encodeURIComponent(jobId)}/retry`, {}),
  cancelPending: (lane) => apiService.delete(`/api/scheduler/pending/${lane}`),
  propertyDebug: (propertyId) => apiService.get(`/api/scheduler/properties/${encodeURIComponent(propertyId)}/debug`),
  retryGallery: (propertyId) => apiService.post(`/api/scheduler/properties/${encodeURIComponent(propertyId)}/gallery-retry`, {}),
}
